import VueRouter from 'vue-router';
import Section from './components/section-component'
import SubSection from './components/subsection-component'
import Page from './components/page-component'

const _routes = [
    {
        path: '/',
        redirect: '/accueil'
    },
    {
        path: '/:sectionSlug',
        component: Section,
        name: 'section'
    },
    {
        path: '/:sectionSlug/:subsectionSlug',
        component: SubSection,
        name: 'SubSection'
    },
    {
        path: '/:sectionSlug/:subsectionSlug/:pageSlug',
        component: Page,
        name: 'page'
    }
]

var router = new VueRouter({
    mode: 'history',
    base: __dirname,
    routes: _routes,
    linkActiveClass: 'active'
})

export default router
